<template>
  <div class="md-layout" style="margin-bottom: 2em;">
    <div class="md-layout-item vertical-middle md-size-100">
      <div class="md-layout md-gutter">
        <div class="md-layout-item  ">
          <md-field>
            <label for="movie">Action type</label>
            <md-select v-model="action.allotment_value_format">
              <md-option value="PERCENTAGE">% of inventory</md-option>
              <md-option value="ABSOLUTE">Inventory</md-option>
              <md-option value="OPEN_SALES">Open Sales</md-option>
              <md-option value="STOP_SALES">Stop sales</md-option>
              <md-option value="MLOS">MLOS</md-option>
            </md-select>
          </md-field>
        </div>
        <div class="md-layout-item   ">
          <md-field v-if="action.allotment_value_format !== 'OPEN_SALES' && action.allotment_value_format !== 'STOP_SALES'">
            <label v-if="action.allotment_value_format == 'PERCENTAGE'">%</label>
            <label v-if="action.allotment_value_format == 'ABSOLUTE'">Amount</label>
            <md-input v-model="action.amount"></md-input>
          </md-field>
        </div>
      </div>
    </div>
    <div v-if="action.allotment_value_format == 'ABSOLUTE'" class="md-layout-item md-size-100 vertical-middle">
      <md-checkbox v-model="action.hotel_overbooking">
        Overbooking hotel
      </md-checkbox>
    </div>
    <div
      v-if="action.allotment_value_format == 'PERCENTAGE' || action.allotment_value_format == 'ABSOLUTE'"
      class="md-layout-item md-size-100 vertical-middle"
    >
      <div class="md-layout md-gutter md-alignment-center-left">
        <span class="md-layout-item md-size-20 " style="white-space: nowrap">Discount from</span>
        <div class="md-layout-item  md-size-30 ">
          <room-type-select v-model="action.discount_from_room_type_ids" multiple></room-type-select>
        </div>
      </div>
      <md-button title="Add rule" v-if="button" class="md-white md-just-icon" @click="addActionTo"><md-icon>add</md-icon></md-button>
    </div>
    <div v-if="action.allotment_value_format == 'MLOS'" class="md-layout-item vertical-middle md-size-100 ">
      <div class="md-layout  md-gutter">
        <div class=" md-layout-item  md-size-100 "><span>Extra conditions</span></div>
        <ValidationProvider
          name="Min occ before"
          :rules="'required'"
          v-slot="{ passed, failed, errors }"
          class=" md-layout-item md-size-50 md-theme-default"
        >
          <md-field
            style="display: inline-flex"
            class="md-field"
            :class="[{ 'md-error': failed }, { 'md-invalid': failed }, { 'md-valid': passed }]"
          >
            <label>Minumum Occ day before</label>
            <md-input type="number" v-model="action.min_occ_before" />
            <span class="radio-error" :class="[{ 'md-error': failed }]">{{ errors[0] }}</span>
          </md-field>
        </ValidationProvider>
        <ValidationProvider
          name="Min occ after"
          :rules="'required'"
          v-slot="{ passed, failed, errors }"
          class=" md-layout-item md-size-50 md-theme-default"
        >
          <md-field
            style="display: inline-flex"
            class="md-field"
            :class="[{ 'md-error': failed }, { 'md-invalid': failed }, { 'md-valid': passed }]"
          >
            <label>Minumum Occ day atfer</label>
            <md-input type="number" v-model="action.min_occ_after" />
            <span class="radio-error" :class="[{ 'md-error': failed }]">{{ errors[0] }}</span>
          </md-field>
        </ValidationProvider>
      </div>
    </div>
    <div
      v-if="action.allotment_value_format == 'OPEN_SALES' || action.allotment_value_format == 'STOP_SALES'"
      class="md-layout-item vertical-middle md-size-100 "
    >
      <div class="md-layout  md-gutter">
        <div class=" md-layout-item  md-size-100 "><span>Extra conditions</span></div>
        <ValidationProvider
          name="Min occ"
          :rules="'required'"
          v-slot="{ passed, failed, errors }"
          class=" md-layout-item md-size-50 md-theme-default"
        >
          <md-field
            style="display: inline-flex"
            class="md-field"
            :class="[{ 'md-error': failed }, { 'md-invalid': failed }, { 'md-valid': passed }]"
          >
            <label>Minumum Occ</label>
            <md-input type="number" v-model="action.min_occ" />
            <span class="radio-error" :class="[{ 'md-error': failed }]">{{ errors[0] }}</span>
          </md-field>
        </ValidationProvider>
        <div class="md-layout-item  ">
          <md-field>
            <label for="movie">Minumum consecutive days</label>
            <md-select v-model="action.consecutive_days">
              <md-option value="1">1</md-option>
              <md-option value="2">2</md-option>
              <md-option value="3">3</md-option>
              <md-option value="4">4</md-option>
              <md-option value="5">5</md-option>
            </md-select>
          </md-field>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RoomTypeSelect from '../Inputs/RoomTypeSelect.vue'

export default {
  name: 'AllotmentRuleActions',
  props: {
    action: Object,
    button: Boolean,
  },
  components: {
    RoomTypeSelect,
  },
  methods: {
    addActionTo() {
      this.$emit('addAction')
    },
  },
  created() {},
}
</script>

<style lang="scss"></style>
